<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Saira:500|Work+Sans:300,400&display=swap');
  @import 'assets/css/reset';
  @import 'node_modules/bootstrap/scss/bootstrap';
  @import 'node_modules/bootstrap-vue/src/index.scss';
  @import 'assets/scss/main';
</style>



// WEBPACK FOOTER //
// src/App.vue